exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-parent {\n  display: block;\n  position: relative; }\n  .search-parent .search-btn {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 11px;\n    cursor: pointer;\n    border-radius: 0 5px 5px 0; }\n    .search-parent .search-btn:hover {\n      background: rgba(0, 0, 0, 0.1); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/searchComponent/search-component.component.scss
// module id = ../../../../../app/shared/components/searchComponent/search-component.component.scss
// module chunks = main